import { object, date, ref } from "yup";

const getHistorySchema = object().shape({
  startTime: date(),
  endTime: date().test(
    "timeRequirement",
    "請填寫開始或結束日期",
    function (value) {
      try {
        const startTime = this.resolve(ref("startTime"));
        return startTime || value;
      } catch (err) {
        console.error(err);
        return false;
      }
    },
  ),
});

export { getHistorySchema };
